export default __webpack_public_path__ + "static/media/crowd_gilets_jaunes.29739195.jpg";